// extracted by mini-css-extract-plugin
export default {"root":"ScreenError_root__ehmCe","icon":"ScreenError_icon__pJgEr","message":"ScreenError_message__Zk01U"};